var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MinDate } from "class-validator";
import { GraphQLNonEmptyString } from "graphql-scalars";
import { Field, InputType, ObjectType } from "type-graphql";
import { ConfigurationNode } from "../resources/Configuration.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
let GetConfigurationResponse = class GetConfigurationResponse {
    data;
};
__decorate([
    Field(() => ConfigurationNode, { nullable: false }),
    __metadata("design:type", ConfigurationNode)
], GetConfigurationResponse.prototype, "data", void 0);
GetConfigurationResponse = __decorate([
    ObjectType("GetConfigurationByUuidResponse")
], GetConfigurationResponse);
export { GetConfigurationResponse };
let CreateConfigurationInput = class CreateConfigurationInput {
    key;
    value;
    validAfter;
    validUntil;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], CreateConfigurationInput.prototype, "key", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], CreateConfigurationInput.prototype, "value", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], CreateConfigurationInput.prototype, "validAfter", void 0);
__decorate([
    MinDate(() => new Date()),
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], CreateConfigurationInput.prototype, "validUntil", void 0);
CreateConfigurationInput = __decorate([
    InputType()
], CreateConfigurationInput);
export { CreateConfigurationInput };
//# sourceMappingURL=GetConfigurationResponse.js.map